import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { fetchEvents } from "../../actions";
import { Content } from "../layout";
import { pageLimit as limit } from "../../config/keys";
import { communicator_event_types } from "../common/selectable_data";

const EventList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector((state) => state.event.events);

  useEffect(() => {
    dispatch(fetchEvents(page, limit));
  }, [dispatch, page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderStatus = (dateConfirmed) => {
    return (
      <Tooltip title={moment(dateConfirmed).format("YYYY-MM-DD HH:mm:ss")}>
        <Box component="span">처리완료</Box>
      </Tooltip>
    );
  };

  const renderEvents = () =>
    rows.map((event) => (
      <TableRow
        key={event.id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>{event.Worker.name}</TableCell>
        <TableCell>{event.Worker.Application.Organization.name}</TableCell>
        <TableCell>{event.Worker.phone}</TableCell>
        <TableCell>{new Date(event.createdAt).toLocaleString()}</TableCell>
        <TableCell>
          {
            communicator_event_types.find((type) => type.id === event.type)
              .label
          }
        </TableCell>
        <TableCell>
          {event.status === true ? renderStatus(event.dateConfirmed) : "-"}
        </TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            긴급호출현황
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="event-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>이름</TableCell>
                  <TableCell>소속</TableCell>
                  <TableCell>전화번호</TableCell>
                  <TableCell>호출일시</TableCell>
                  <TableCell>종류</TableCell>
                  <TableCell>상태</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderEvents()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
    </Content>
  );
};

export default EventList;
